/**
 * Where a note Y.Doc records that it is a Tiptap note.
 *
 * Web's `NoteDoc` and mobile's DOM notes editor each hold the SAME per-note
 * Y.Doc, but mobile owns its own `Y.Doc` and never goes through sync-client, so
 * the layout both must agree on lives here. Mobile builds that never stamped the
 * kind left web reading a phone-edited note as having no content — which is why
 * web also accepts an unstamped, non-empty `content` fragment as tiptap.
 *
 * Dependency-free (type-only Yjs import) so the DOM/WebView bundle can use it.
 */
import type * as Y from 'yjs';

/** Root Y.Map holding the note kind + scalar metadata. */
export const NOTE_META_MAP_KEY = 'meta';
/** Key inside the meta map that records the note kind. */
export const NOTE_KIND_KEY = 'type';
/** Root Y.XmlFragment holding a Tiptap note's document. */
export const TIPTAP_NOTE_FRAGMENT_KEY = 'content';

/**
 * Record `type: "tiptap"` on the note's meta map if no kind is recorded yet.
 * Never overwrites another kind. Returns whether it wrote.
 *
 * Only call this once the doc has synced with the server: stamping a pre-sync
 * doc races the server's reply through Yjs's Y.Map tiebreaker.
 */
export function stampTiptapNoteKindIfUnset(doc: Y.Doc): boolean {
  const meta = doc.getMap<unknown>(NOTE_META_MAP_KEY);
  if (meta.get(NOTE_KIND_KEY) !== undefined) return false;
  meta.set(NOTE_KIND_KEY, 'tiptap');
  return true;
}
